import React from 'react';
import { CheckCircleOutlined, IssuesCloseOutlined, StopOutlined } from '@ant-design/icons';
import { COLOR_FAILURE, COLOR_SUCCESS, COLOR_WARNING } from 'app-constants';
import { MatchType } from 'types/documentGroup';
import Styled from '../listItemHead.styled';

interface OwnProps {
  matchType: MatchType;
}

const { StyledMatchStatusIcon } = Styled;

const MatchStatusIcon = ({ matchType }: OwnProps) => (
  <>
    {matchType === MatchType.FullMatch && (
      <StyledMatchStatusIcon
        icon={CheckCircleOutlined}
        title='Full match'
        colorToSet={COLOR_SUCCESS}
      />
    )}
    {matchType === MatchType.PartialMatch && (
      <StyledMatchStatusIcon
        icon={IssuesCloseOutlined}
        title='Partial match'
        colorToSet={COLOR_WARNING}
      />
    )}
    {matchType === MatchType.NoMatch && (
      <StyledMatchStatusIcon icon={StopOutlined} title='No match' colorToSet={COLOR_FAILURE} />
    )}
  </>
);

export default MatchStatusIcon;
